import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// REVISA ESTA LÍNEA: debe tener el 'export' antes de 'const'
export const supabase = createClient(supabaseUrl, supabaseAnonKey)